var index = {
  loader: {
    mask: {
      background: '{content.background}',
      color: '{text.muted.color}'
    },
    icon: {
      size: '2rem'
    }
  }
};

export { index as default };
//# sourceMappingURL=index.mjs.map
